import { render, staticRenderFns } from "./ResendEmail.vue?vue&type=template&id=7f3f4063&scoped=true&"
import script from "./ResendEmail.vue?vue&type=script&lang=js&"
export * from "./ResendEmail.vue?vue&type=script&lang=js&"
import style0 from "./ResendEmail.vue?vue&type=style&index=0&id=7f3f4063&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3f4063",
  null
  
)

export default component.exports